import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=95dc27bc&scoped=true"
import script from "./previewDialog.vue?vue&type=script&lang=js"
export * from "./previewDialog.vue?vue&type=script&lang=js"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=95dc27bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dc27bc",
  null
  
)

export default component.exports